import {
  mvpApiGetJobTaskOptions,
  mvpApiListJobTasksOptions,
} from "@labeling-tools/api/lebron/generated/@tanstack/react-query.gen";
import { useFetchParcel } from "@labeling-tools/api/lebron/react-query-hooks";
import { LoadingOverlay } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AdminToolbar } from "../components/AdminToolbar";
import { CoverageBetaTask } from "./CoverageBetaTask";

export const AdminCoverageBetaTask = () => {
  const navigate = useNavigate();
  const job_id = useParams()?.jobId ?? "";
  const [searchParams] = useSearchParams();
  const task_id = searchParams.get("taskId") ?? "";

  const { data: jobTasksResp, isLoading: jobTasksLoading } = useQuery({
    ...mvpApiListJobTasksOptions({ path: { job_id } }),
    enabled: !!job_id,
  });
  const { data: taskDetailResp, isLoading: taskLoading } = useQuery({
    ...mvpApiGetJobTaskOptions({ path: { job_id, task_id } }),
    enabled: !!job_id && !!task_id,
  });

  const parcelId = taskDetailResp?.data?.parcel_id as string | undefined;
  const { data: parcel, isLoading: parcelLoading } = useFetchParcel(parcelId);

  // Default to first task if no taskId in URL
  useEffect(() => {
    if (!taskDetailResp && !task_id && jobTasksResp?.tasks[0]?.id) {
      navigate(
        `/jobs/${job_id}/admin-coverage-beta?taskId=${jobTasksResp.tasks[0].id}`,
        { replace: true },
      );
    }
  }, [taskDetailResp, task_id, job_id, jobTasksResp, navigate]);

  if (jobTasksLoading || taskLoading || parcelLoading) {
    return <LoadingOverlay visible={true} />;
  }

  return (
    <div>
      {/* Admin toolbar */}
      {jobTasksResp && taskDetailResp && (
        <AdminToolbar jobTasks={jobTasksResp} activeTask={taskDetailResp} />
      )}

      {/* Coverage task in admin (read-only) mode — key on task.id to reset all
           internal state (image mutation, zoom, selections) when navigating.
           `adminResult` is the completed payload, hydrated so the task renders
           exactly as it was submitted. */}
      {taskDetailResp && parcel && (
        <CoverageBetaTask
          key={taskDetailResp.id}
          adminTask={taskDetailResp}
          adminResult={taskDetailResp.result}
        />
      )}
    </div>
  );
};
